import { EntityBase } from 'src/app/shared/model/generic/entityBase';

export class PedidoIntervencao extends EntityBase {
    public pedidoIntervencaoId: number;
    public autorizacaoEstadoId: number;
    public estado: string;
    public data: Date;
    public dataEntradaOficina?: Date;
    public contratoId: number;
    public numContrato: string;
    public matricula: string;
    public produto: string;
    public fornecedorId: number;
    public oficinaId: number;
    public numKms: number;
    public descritivo: string;
    public tipoIntervencao: number[];
    public artigoFamilia: number[];
    public update: boolean;
    public readOnly: boolean;
}
